<div *ngIf="user">
  <div class="text-danger" *ngIf="user.blocked" id="blocked">
    <i class="fas fa-ban"></i><strong>BLOCKED</strong>: User has been blocked by
    an Auth0 admin. The user cannot be unblocked from Back Office.
  </div>

  <div *ngIf="user.blockedByLogin" id="blocked-by-login">
    <div class="text-danger">
      <i class="fas fa-ban"></i><strong>BLOCKED</strong>: User has been blocked
      by to many login attempts.
    </div>
    <app-button
      bsClass="danger"
      labeled="true"
      [showLoader]="isUnblockingUser"
      (handleClick)="deleteBlockedByLogin.emit($event)"
      [disabled]="user.blocked"
      [tooltip]="
        user.blocked
          ? 'You can\'t unblock user that has been blocked by an Auth0 admin'
          : ''
      "
      >Unblock user</app-button
    >
  </div>

  <div id="blocked-by-backoffice" *ngIf="!user.blocked && canBlock">
    <app-button bsClass="danger" (handleClick)="blockUser.emit()">
      Block
    </app-button>
  </div>
</div>
